import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { Button, Link, MessagePlugin, Popconfirm, Space, Table } from 'tdesign-react';
import { connect } from 'react-redux';
import { fetchLibOptions, fetchProxyOptions } from '@/slices/resourceSlice';
import { deleteEnv, getEnvList } from '@/services/resourceService';
import useTable from '@/hooks/useTable';
import PermWrapper from '@/components/PermWrapper';
import { renderDateTime } from '@/utils/common';
import FormModal from './FormModal';

function EnvPanel({ fetchProxyOptions, fetchLibOptions }) {
  const [visible, setVisible] = useState(false);
  const [currentRow, setCurrentRow] = useState();

  /**
   * @type {import('tdesign-react/lib/table/type').BaseTableCol}
   */
  const columns = [
    {
      colKey: 'envName',
      title: '环境名称',
      fixed: 'left',
      width: 150,
    },
    {
      colKey: 'envKey',
      title: '唯一标识符',
      width: 150,
    },
    {
      colKey: 'note',
      title: '环境说明',
      ellipsis: true,
      width: 180,
    },
    {
      colKey: 'proxyName',
      title: '关联代理名称',
      width: 150,
    },
    {
      colKey: 'productLibName',
      title: '关联制品库信息',
      width: 150,
    },
    {
      title: '创建人',
      colKey: 'createBy',
      width: 150,
    },
    {
      title: '最后修改人',
      colKey: 'updateBy',
      width: 150,
    },
    {
      title: '创建时间',
      colKey: 'createdTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      title: '更新时间',
      colKey: 'updateTime',
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Space>
          <PermWrapper resource='pulsar:resource:env:update'>
            <Link
              theme='primary'
              onClick={() => {
                setVisible(true);
                setCurrentRow(row);
              }}
              hover='color'
            >
              编辑
            </Link>
          </PermWrapper>
          <PermWrapper resource='pulsar:resource:env:delete'>
            <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
              <Link theme='danger' hover='color'>
                删除
              </Link>
            </Popconfirm>
          </PermWrapper>
        </Space>
      ),
      width: 120,
    },
  ];

  const loadData = useMemoizedFn(async () => {
    const { data } = await getEnvList();
    setData(data.envInfoList);
  });

  const createEnv = () => {
    setVisible(true);
    setCurrentRow(null);
  };

  const { header, setData, config, doRefresh } = useTable({
    columns,
    onSearch: loadData,
    operators: (
      <PermWrapper resource='pulsar:resource:env:create'>
        <Button onClick={createEnv}>新建环境</Button>
      </PermWrapper>
    ),
  });

  useEffect(() => {
    loadData();
    fetchProxyOptions();
    fetchLibOptions();
  }, [loadData, fetchProxyOptions, fetchLibOptions]);

  const doDelete = async ({ envId }) => {
    try {
      await deleteEnv({ envId });
      MessagePlugin.success('删除成功');
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    }
  };

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      doRefresh();
    }
  };

  return (
    <>
      {header}
      <Table {...config} />
      <FormModal visible={visible} detail={currentRow} handleClose={handleClose} />
    </>
  );
}

export default connect(null, {
  fetchProxyOptions,
  fetchLibOptions,
})(EnvPanel);
